<div class="content">
	<div class="content-top">
		<ng-content select="[create]"></ng-content>
		<ng-content select="[total]"></ng-content>
	</div>
	<div class="content-bottom">
		<div class="filters">
			<ng-content select="[filters]"></ng-content>
		</div>
		<div class="actions">
			<button
				dsButton
				view="normal-secondary"
				size="S"
				(click)="refresh()()"
				[disabled]="loading()"
				[loading]="loading()"
			>
				<ds-icon-swap [iconName]="'icon-arrow-reissue-20'"></ds-icon-swap>
			</button>
			<button
				dsButton
				[disabled]="loading()"
				[loading]="loading()"
				size="S"
				view="normal-secondary"
				(click)="export()()"
				[iconLeftProps]="{ name: 'icon-export-20', form: 'square' }"
			>
				{{ "gl.xlsx" | translate }}
			</button>
		</div>
	</div>
</div>
